(function () {
  'use strict';
  var root = document.querySelector('[data-hp-manual]');
  if (!root || !window.HPManualContext) return;
  var params = new URLSearchParams(location.search);
  var products = window.HPManualContext.resolveProducts(params);
  var visibleCount = 0;
  root.querySelectorAll('[data-manual-product]').forEach(function (section) {
    section.hidden = !products.includes(section.dataset.manualProduct);
    section.classList.toggle('hp-guide__product--following', !section.hidden && visibleCount > 0);
    if (!section.hidden) visibleCount++;
  });
  root.querySelectorAll('[data-manual-nav]').forEach(function (link) {
    link.hidden = !products.includes(link.dataset.manualNav);
  });
  root.querySelector('.hp-guide__nav').hidden = products.length < 2;
  root.querySelector('[data-manual-empty]').hidden = products.length > 0;
  if (params.has('preview_theme_id')) {
    root.querySelector('[data-manual-all]').href += '&preview_theme_id=' + encodeURIComponent(params.get('preview_theme_id'));
  }

  function normalizedText(node) {
    return node.textContent.replace(/\s+/g, '');
  }

  // Build presentation around the original Shopify copy, including its links
  // and emphasis. If its structure changes, keep the original text intact.
  function layoutPureCopy() {
    var source = root.querySelector('[data-pure-copy]');
    var images = root.querySelector('[data-pure-art]').content.querySelectorAll('img');
    var headings = Array.from(source.querySelectorAll('strong')).filter(function (node) {
      return /^(COMO UTILIZAR|[123]ª Etapa|IMPORTANTE|APÓS O PRIMEIRO)/.test(node.textContent.trim());
    });
    var care = Array.from(source.querySelectorAll('span')).find(function (node) {
      return node.textContent.trim().startsWith('- Faça uma limpeza semanal');
    });
    if (headings.length !== 8 || !care || images.length !== 5) return;
    var boundaries = headings.concat(care);
    var chunks = boundaries.map(function (node, index) {
      var range = document.createRange();
      range.setStartBefore(node);
      if (boundaries[index + 1]) range.setEndBefore(boundaries[index + 1]);
      else range.setEnd(source, source.childNodes.length);
      var fragment = range.cloneContents();
      fragment.querySelectorAll('meta').forEach(function (meta) { meta.remove(); });
      // Only trim empty formatting nodes, never text.
      while (fragment.lastChild && !fragment.lastChild.textContent.trim()) fragment.lastChild.remove();
      return fragment;
    });
    var output = document.createDocumentFragment();
    function block(tag, className, chunk) {
      var el = document.createElement(tag);
      el.className = className;
      el.append(chunk);
      return el;
    }
    function steps(indices, imageOffset, routine) {
      var list = document.createElement('ol');
      list.className = 'hp-guide__steps' + (routine ? ' hp-guide__steps--routine' : '');
      indices.forEach(function (index, position) {
        var item = document.createElement('li');
        item.className = 'hp-guide__step';
        item.append(block('div', 'hp-guide__art', images[imageOffset + position].cloneNode(true)));
        item.append(block('div', 'hp-guide__step-copy', chunks[index]));
        list.append(item);
      });
      return list;
    }
    output.append(block('h3', 'hp-guide__section-title', chunks[0]));
    output.append(steps([1, 2, 3], 0, false));
    output.append(block('aside', 'hp-guide__note', chunks[4]));
    output.append(block('h3', 'hp-guide__section-title', chunks[5]));
    output.append(steps([6, 7], 3, true));
    output.append(block('div', 'hp-guide__care', chunks[8]));
    if (normalizedText(output) !== normalizedText(source)) return;
    source.replaceChildren(output);
    source.dataset.copyPreserved = 'true';
  }
  if (products.includes('pure')) layoutPureCopy();
})();
